import { inferTypeForFilterStore } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';

export const getDimension = (primaryFilterValues: PrimaryFilterSelection[]) => {
  const employeeGroupLevel = primaryFilterValues.find(
    (filter) => filter.primaryFilterKey === 'employeeGroup',
  );

  if (!employeeGroupLevel) {
    return null;
  }

  const infer = inferTypeForFilterStore(employeeGroupLevel.value);

  if (infer.type !== 'string[]' || infer.stringArray.length !== 2) {
    return null;
  }

  return infer.stringArray[0];
};
